function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Link } from 'react-router-dom';
import { Button, CustomModal, TextButton, Typography, useOverlayContext } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import { useResponsive } from "../../client-flow/contexts";
import { GoogleMapsProvider, loadGoogleMaps } from "../../components/AddressAutocomplete";
import ExternalLinkButton from "../../components/ExternalLinkButton";
import { SecureLoginModal } from "../../components/SecureLoginModal/SecureLoginModal";
import { useQboInVob } from "../../components/VendorOnboardingModal/useQboInVob";
import VendorOnboardingModal from "../../components/VendorOnboardingModal/VendorOnboardingModal";
import { openInNewTabProps } from "../../constants";
import { useEventReporter } from "../../event-reporter";
import { useFeatureFlags } from "../useFeatureFlags";
import { useStore, useStoreActions } from "../../store/store-context";
import styles from "./useCreateVendorAccount.module.scss";

// Exported handler function that can be used directly when feature flag is enabled
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const handleCreateVendorAccountApprove = async (userInfo, api, logBI, reportToHeap, reportToHubspot) => {
  logBI(18101);
  reportToHubspot('create_vendor_account_approve_v4');
  reportToHeap('top-bar', 'click', 'client-create-vendor-account-approve');
  if (!(userInfo !== null && userInfo !== void 0 && userInfo.hasApprovedTermsOfService())) {
    const userId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id();
    if (userId) {
      await api.auth.approveTos(userId);
    }
  }
};
const CreateVendorAccountConfirmationModalWithFF = _ref => {
  let {
    dismissModal
  } = _ref;
  const userInfo = useStore(state => state.userInfo);
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const {
    isDesktop
  } = useResponsive();
  return /*#__PURE__*/_jsx(CustomModal, {
    maxWidth: isDesktop ? 600 : '100%',
    maxHeight: isDesktop ? '90vh' : '100%',
    title: "Create Service Provider account",
    onClose: () => {
      dismissModal(false);
      reportToHubspot('create_vendor_account_canceled_v3');
    },
    "data-testid": "create-vendor-account-confirmation",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      style: {
        padding: isDesktop ? 0 : '8px'
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.bodyContainer,
        children: [/*#__PURE__*/_jsx(AnchorLogo, {
          width: 180,
          height: 50,
          className: styles.logo
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          className: styles.title,
          children: "Create a Service Provider account"
        }), /*#__PURE__*/_jsx(Typography, {
          className: styles.message,
          variant: "h6",
          skin: "disabled",
          children: "Anchor allows service providers to fully automate their billing, in a simple, flexible, and affordable way. Send proposals, get them signed, invoiced, paid, and fully synced to your favorite accounting software - all automatically!"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.footer,
        style: _objectSpread({}, !isDesktop && {
          padding: '8px'
        }),
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(Typography, {
            as: "span",
            variant: "paragraph2",
            skin: "disabled",
            weight: "light",
            children: ["By creating a Seller account, you agree to our", ' ']
          }), /*#__PURE__*/_jsx(TextButton, _objectSpread(_objectSpread({
            as: Link,
            variant: "paragraph2",
            skin: "secondary",
            to: {
              pathname: 'https://www.sayanchor.com/terms-of-contact'
            }
          }, openInNewTabProps), {}, {
            underline: "none",
            children: "Terms of Service"
          })), /*#__PURE__*/_jsxs(Typography, {
            as: "span",
            variant: "paragraph2",
            skin: "disabled",
            weight: "light",
            children: [' ', "and", ' ']
          }), /*#__PURE__*/_jsx(TextButton, _objectSpread(_objectSpread({
            as: Link,
            variant: "paragraph2",
            skin: "secondary",
            to: {
              pathname: 'https://www.sayanchor.com/privacy-policy'
            }
          }, openInNewTabProps), {}, {
            underline: "none",
            children: "Privacy policy"
          })), /*#__PURE__*/_jsx(Typography, {
            as: "span",
            variant: "paragraph2",
            skin: "disabled",
            weight: "light",
            children: "."
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.actions,
          style: _objectSpread({}, !isDesktop && {
            alignItems: 'center'
          }),
          children: [/*#__PURE__*/_jsx(ExternalLinkButton, {
            style: _objectSpread({}, !isDesktop && {
              height: '100%'
            }),
            testid: 'client-create-vendor-book-a-demo',
            openInNewTab: true,
            size: "medium",
            underline: "none",
            className: styles.demoButton,
            href: "https://meetings.hubspot.com/tal57/book-a-demo-website?utm_source=in-app&utm_medium=client_to_vendor&utm_campaign=get_a_demo_button",
            children: "Book a demo"
          }), /*#__PURE__*/_jsx(Button, {
            size: "medium",
            style: _objectSpread({}, !isDesktop && {
              height: '100%'
            }),
            onClick: async () => {
              await handleCreateVendorAccountApprove(userInfo, api, logBI, reportToHeap, reportToHubspot);
              await dismissModal(true);
            },
            "data-testid": "create-vendor-account-approve-btn",
            children: "Create Service Provider account"
          })]
        })]
      })]
    })
  });
};
export const useCreateVendorAccount = onClick => {
  const userInfo = useStore(state => state.userInfo);
  const {
    setWorksAt,
    api,
    logBI
  } = useStoreActions();
  const {
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const overlayContext = useOverlayContext();
  const {
    SET_IDENTITY_ONLY_TOKEN_FE,
    CLIENT_TO_SERVICE_PROVIDER_IMPROVEMENTS
  } = useFeatureFlags();
  const showQboStep = useQboInVob();
  const onCreateVendorAccount = async () => {
    onClick === null || onClick === void 0 || onClick();
    reportToHubspot('create_vendor_account_clicked_v2');
    reportToHeap('top-bar', 'click', 'client-create-vendor-account-topbar');
    let hasIdentity = !!(userInfo !== null && userInfo !== void 0 && userInfo.hasIdentity());
    if (!hasIdentity && !SET_IDENTITY_ONLY_TOKEN_FE) {
      hasIdentity = await overlayContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;
          return /*#__PURE__*/_jsx(SecureLoginModal, {
            dismissModal: dismissModal
          });
        }
      });
    }
    if (hasIdentity || SET_IDENTITY_ONLY_TOKEN_FE) {
      if (CLIENT_TO_SERVICE_PROVIDER_IMPROVEMENTS) {
        await handleCreateVendorAccountApprove(userInfo, api, logBI, reportToHeap, reportToHubspot);
        setWorksAt();
        await overlayContext.showModal({
          content: _ref3 => {
            let {
              dismissModal
            } = _ref3;
            return /*#__PURE__*/_jsx(GoogleMapsProvider, {
              loadGoogleMaps: loadGoogleMaps,
              children: /*#__PURE__*/_jsx(VendorOnboardingModal, {
                dismissModal: dismissModal,
                showQboStep: !!showQboStep
              })
            });
          },
          closeOnClickOutside: false,
          shouldBlurBackground: true
        });
      } else {
        const shouldCreateAVendorAccount = await overlayContext.showModal({
          closeOnClickOutside: true,
          closeOnEscapeKey: true,
          content: _ref4 => {
            let {
              dismissModal
            } = _ref4;
            return /*#__PURE__*/_jsx(CreateVendorAccountConfirmationModalWithFF, {
              dismissModal: dismissModal
            });
          }
        });
        if (shouldCreateAVendorAccount) {
          await setWorksAt();
        }
      }
    } else {
      reportToHubspot('create_vendor_account_canceled_v3');
    }
  };
  return onCreateVendorAccount;
};